import {AxiosPromise} from 'axios';
import FormData from 'form-data';

import {CUSTOMER} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {API_URL, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'constants/api';
import {CLIENT_ID, SITE_ID} from 'constants/app';
import {instanceGusaBackend} from 'libs/api';
import {ActionType} from '@typescript/common/actionTypes';
import {AuthorizationType} from '@typescript/common/authorizationTypes';

/**
 * Send data to registration user
 * @param {AuthorizationType} regData - data
 * @returns {ActionType<AxiosPromise>} - return data
 */
export function sendRegistration(regData: AuthorizationType): ActionType<AxiosPromise> {
    const data = {
        firstname: regData.firstName,
        lastname: regData.lastName,
        email: regData.email,
        password: regData.password,
        newsletter: regData.isSubscribed,
        isAgreedPrivacyPolicy: regData.isAgreedPrivacyPolicy,
        websiteId: SITE_ID,
        clientId: CLIENT_ID,
        registrationMethod: 'default',
    };

    return {
        type: CUSTOMER.SEND_REGISTRATION,
        payload: instanceGusaBackend({
            method: 'post',
            baseURL: API_URL,
            url: ENDPOINTS.CUSTOMER_REGISTRATE,
            data,
        }),
    };
}

/**
 * Send data to forgot user
 * @param {string} email - email
 * @param {string} formKey - formKey
 * @returns {ActionType<AxiosPromise>} - return data
 */
export function sendForgot(email: string, formKey: string): ActionType<AxiosPromise> {
    const data = new FormData();

    data.append('email', email);
    data.append('form_key', formKey);

    return {
        type: 'SEND_FORGOT',
        payload: instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
            },
            method: 'post',
            url: ENDPOINTS.CUSTOMER_FORGOT_PASSWORD,
            data,
        }),
    };
}
